import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MASCOT } from "@/lib/api";
import { LayoutDashboard, LogOut, Plus, Shield } from "lucide-react";

export function Logo({ className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img src={MASCOT.tilt} alt="Solange" className="w-11 h-11 rounded-full object-cover border-2 border-[#c17f3e] bg-white" />
      <div className="leading-none">
        <div className="font-brand text-xl font-600 text-[#9c5f27]" style={{ fontWeight: 600 }}>
          Solange
        </div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#c17f3e] font-semibold">a Postadora</div>
      </div>
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthed = user && typeof user === "object";

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-[#e8d8c8]" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="flex items-center gap-2 sm:gap-3">
          {!isAuthed && (
            <>
              {location.pathname !== "/" && (
                <Link to="/" className="hidden sm:block text-sm font-medium text-[#5c4634] hover:text-[#9c5f27] px-3 py-2" data-testid="nav-home">
                  Planos
                </Link>
              )}
              <Link to="/login" className="text-sm font-semibold text-[#9c5f27] hover:text-[#f0791f] px-4 py-2 rounded-full" data-testid="nav-login">
                Entrar
              </Link>
              <Link to="/#planos" className="btn-orange text-sm font-semibold px-5 py-2.5 rounded-full" data-testid="nav-subscribe">
                Assinar
              </Link>
            </>
          )}
          {isAuthed && (
            <>
              {user.role === "admin" ? (
                <Link to="/admin" className="flex items-center gap-1.5 text-sm font-medium text-[#5c4634] hover:text-[#9c5f27] px-3 py-2" data-testid="nav-admin">
                  <Shield size={16} /> <span className="hidden sm:inline">Admin</span>
                </Link>
              ) : (
                <>
                  <Link to="/painel" className="flex items-center gap-1.5 text-sm font-medium text-[#5c4634] hover:text-[#9c5f27] px-3 py-2" data-testid="nav-dashboard">
                    <LayoutDashboard size={16} /> <span className="hidden sm:inline">Painel</span>
                  </Link>
                  <Link to="/novo" className="btn-orange flex items-center gap-1.5 text-sm font-semibold px-4 py-2.5 rounded-full" data-testid="nav-new-product">
                    <Plus size={16} /> <span className="hidden sm:inline">Novo produto</span>
                  </Link>
                </>
              )}
              <button onClick={handleLogout} className="flex items-center gap-1.5 text-sm font-medium text-[#8c735f] hover:text-[#d9640d] px-3 py-2" data-testid="nav-logout">
                <LogOut size={16} /> <span className="hidden sm:inline">Sair</span>
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
